import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-52c8c299"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-bold text-center text-indigo-900 mb-12" }, "SchoolMeet.AI", -1))
const _hoisted_2 = {
  id: "login-screen",
  class: "p-8 rounded-2xl bg-white shadow max-w-sm w-full mx-auto"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold text-black mb-6" }, "Password Reset", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "block text-gray-700 font-medium mb-2"
}, "Email", -1))
const _hoisted_7 = {
  type: "submit",
  class: "w-full rounded-md bg-indigo-600 px-6 py-3 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  "aria-hidden": "true",
  role: "status",
  class: "inline mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
  fill: "#1C64F2"
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-green-500 font-bold" }, " We have sent a password recover instructions to your email. ", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "text-center pt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.isPasswordResetLinkSent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("form", {
              id: "login-form",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  type: "text",
                  class: "w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500",
                  placeholder: "Email",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("button", _hoisted_7, [
                (!_ctx.isFetching)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Reset Password"))
                  : _createCommentVNode("", true),
                (_ctx.isFetching)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_12))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15)),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_router_link, { to: "/auth/login" }, {
          default: _withCtx(() => [
            _createTextVNode("Login")
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}